import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default [
  {
    path: '/delivery-scheduler',
    name: 'Delivery Scheduler',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery-scheduler'),
  },
  {
    path: '/delivery-scheduler/create',
    name: 'Delivery Scheduler Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery-scheduler/create'),
  },
  {
    path: '/delivery-scheduler/:id',
    name: 'Delivery Scheduler Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery-scheduler/detail'),
  },
]
